/**
 * 车辆审核(道闸)
 * http://mockjs.com/
 */
import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

Mock.mock(/visits\/exiting\/process\/steps/, 'get' + mockSwitch, {
  'code': 0,
  'data': {
    'page|+1': 1,
    'count': 10,
    'total_count': 40,
    'review_process_steps|10': [{
      'exiting_process_id|+2': 1, // 对应审核流程的ID
      'step_id': 1, // 当前流程步骤的ID
      'step_no': 2, // 步骤编号
      'status': 1, // 步骤状态
      'status_code': /not_started|pending_review|rejected|approved|canceled/, // 步骤状态code: not_started|pending_review|rejected|approved|canceled
      'title': '步骤一', // 步骤名称
      'exiting_process_sponsor': '陈晓燕(续保专员)', // 发起人名称和角色
      'visit': {
        'visit_id': 1, // 到店记录ID
        'car_id|+1': 1, // car_id
        'plate_number': '粤B@Integer(11111,99999)', // 车牌
        'car_users': ['张三（已绑定）', '张四（未绑定）', '张三（已绑定）', '张四（未绑定）', '张三（已绑定）', '张四（未绑定）'], // 联系人列表，可能为NULL
        'visited_at': Mock.Random.datetime('2017-01-dd HH:mm:ss'), // 进店时间
        'employee_name': '大乔', // 续保专员
        'insurance_rating': 'D', // 客户级别
        'insurance_expires_on': '2017-06-29', // 保险到期日
        'insurance_expires_in': 32, // 保险到期剩余天数
        'is_entered_workshop|1': true, // 是否进过车间
        'has_exiting_process|1': true, // 是否发起过放行流程
        'is_in_processing|1': true, // 是否处于流程审批中
        'can_start_exiting_process|1': true, // 是否可以发起放行
        'exiting_process_sponsor': '陈晓燕(续保专员)', // 发起人名称和角色
        'workshop_visited_at': Mock.Random.datetime('2017-01-dd HH:mm:ss'), // 进车间时间
        'workshop_left_at': Mock.Random.datetime('2017-01-dd HH:mm:ss') // 出车间时间
      }
    }]
  },
  'message': 'ok'
})

// 审核
// /api/v1/visits/exiting/process/steps/{step_id}/approve
Mock.mock(/visits\/exiting\/process\/steps/, 'patch' + mockSwitch, {
  'code': 0,
  'message': 'ok'
})

// 所有待放行车辆
Mock.mock(/^\/api\/v1\/visits\/exiting$/, 'get' + mockSwitch, {
  'code': 0,
  'message': 'ok',
  'data': {
    'page': 1, // 页数
    'count': 10, // 每页大小
    'total_count': 40, // 总数
    'visits|10': [{
      'visit_id': 1, // 到店记录ID
      'car_id': 1, // car_id
      'exiting_process_sponsor': '陈晓燕(续保专员)', // 发起人名称和角色
      'plate_number': '粤B@Integer(11111,99999)', // 车牌
      'visited_at': Mock.Random.datetime('2017-01-dd HH:mm:ss'), // 进店时间
      'workshop_visited_at': Mock.Random.datetime('2017-01-dd HH:mm:ss'), // 进车间时间
      'workshop_left_at': Mock.Random.datetime('2017-01-dd HH:mm:ss'), // 出车间时间
      'in_exiting_process|1': true, // 是否正在放行
      'can_start_exiting_process|1': true // 是否可以发起放行
    }]
  }
})
